// Get locale from cookie
const getLocaleFromCookie = () => {
  const match = document.cookie.match(/(^|;)\s*locale=([^;]*)/)
  return match ? decodeURIComponent(match[2]) : "en"
}

const PageTitle = ({
  title,
  subtitle,
}) => {
  const locale = getLocaleFromCookie()


  return (
	 <div className="container mt-5 mt-xl-10">
      <div className="row mb-5 g-3 g-xl-5 align-items-end">
        <div className="col-lg-12">
          <h1 style={{ lineHeight: '80%' }}>
			<span className="display-2 text-black" style={{ fontWeight: 'bold', lineHeight: '50%' }}>{title}</ span>
	  		{subtitle && ( <span className="display-4 text-black" style={{ lineHeight: '50%' }}><br />{subtitle}</ span> )}
	  	  </h1>
        </div>
      </div>
    </div>
  )
}

export default PageTitle
